import React, { useRef } from 'react';
import { FieldRadioButton } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import { required } from '../../../util/validators';
import css from '../EditListingDescriptionForm.css';
import { RIDINGS_PER_WEEK, RIDINGS_PER_WEEK_MODERATE } from '../../../marketplace-custom-config';
import { useIntl } from 'react-intl';
import { usePrefilledValue } from '../../../components/EditListingWizard/hooks/usePrefilledValue';
import { getPrefilledValueFromHorseType } from '../../../components/EditListingWizard/Helpers';
import { EDIT_LISTING_TAB_REQUIREMENTS } from '../../../components/EditListingWizard/config';
import { PrefilledValueTooltip } from '../../../components/EditListingWizard/Components/PrefilledValueTooltip/PrefilledValueTooltip';

const fieldName = 'availability';

export default ({ form, values }) => {
    const intl = useIntl();
    const containerRef = useRef();

    const prefilledValue =
        getPrefilledValueFromHorseType({
            tab: EDIT_LISTING_TAB_REQUIREMENTS,
            values,
        }) || RIDINGS_PER_WEEK_MODERATE;

    const { showPrefilledValue } = usePrefilledValue({
        form,
        fieldName,
        prefilledValue,
    });

    return (
        <div>
            <div>
                <h1 className={css.horseTypeTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.desiredAvailabilityTitle" />
                </h1>
                <p className={css.horseTypeSubTitle}>
                    <FormattedMessage id="EditListingDescriptionForm.desiredAvailabilitySubTitle" />
                </p>
                <div ref={containerRef}>
                    {RIDINGS_PER_WEEK.map(optionName => {
                        const isPrefilledValue =
                            showPrefilledValue && optionName === prefilledValue;

                        return (
                            <FieldRadioButton
                                key={optionName}
                                form={form}
                                id={optionName}
                                value={optionName}
                                name={fieldName}
                                validate={required('Dieses Feld wird benötigt')}
                                label={intl.formatMessage({
                                    id: `EditListingDescriptionForm.desiredAvailabilityRadioButton-${optionName}`,
                                })}
                            >
                                {isPrefilledValue && (
                                    <PrefilledValueTooltip parentContainerRef={containerRef} />
                                )}
                            </FieldRadioButton>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
